import { render, staticRenderFns } from "./RepairsList.vue?vue&type=template&id=1a343814&"
import script from "./RepairsList.vue?vue&type=script&lang=js&"
export * from "./RepairsList.vue?vue&type=script&lang=js&"
import style0 from "./RepairsList.vue?vue&type=style&index=0&id=1a343814&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports